import type { HTMLComponent } from "@commercekit/react";
import type { BlogPostContentPageDocument } from "~/lib/prismic";
import { useLocalePath } from "@commercekit/remix/index";
import { asText } from "@prismicio/helpers";
import { PrismicImage } from "@prismicio/react";

// Thumbnails render at 80x80 CSS px; request that size (2x for retina) instead of the original
const imgixParams = {
  w: 80,
  h: 80,
  fit: "crop" as const,
  auto: ["format" as const, "compress" as const],
};

const WvBlogPagePopularBlog: HTMLComponent<{
  readMore: string;
  popularBlogTitle: string;
  popularBlogPosts: BlogPostContentPageDocument[];
}> = ({ readMore, popularBlogTitle, popularBlogPosts }) => {
  const localePath = useLocalePath();
  return (
    <div className="popularblogs">
      <div className="popularblogs__inner">
        <h2 className="heading mdl strong underlined left py-2 mb-2 mx-3">
          {popularBlogTitle}
        </h2>

        <div className="popularblogpost__wrapper">
          {popularBlogPosts.length > 0 &&
            popularBlogPosts.map((blogPost) => (
              <a
                key={blogPost.uid}
                href={localePath(`/${blogPost.uid}/`)}
                className="popularblogpost px-3"
              >
                <PrismicImage
                  field={blogPost.data?.image}
                  imgixParams={imgixParams}
                  pixelDensities={[1, 2]}
                  fallbackAlt=""
                  className="popularblogpost__img"
                  width={80}
                  height={80}
                  loading="lazy"
                />
                <div className="popularblogpost__content">
                  <h6 className="popularblogpost__title">
                    {asText(blogPost.data?.title)}
                  </h6>
                  <p className="popularblogpost__date" data-icon-after="">
                    {readMore}
                  </p>
                </div>
              </a>
            ))}
        </div>
      </div>
    </div>
  );
};
export default WvBlogPagePopularBlog;
